import subdivisions from '@root/helpers/schema/country_subdivisions.json';
import subdivisions_ppl from '@root/helpers/schema/country_subdivisions_ppl.json';
import { isPPL } from '@root/helpers/utils';
import type { KeywordDefinition } from 'ajv';

const getCountrySubdivisions = () => {
  if (import.meta.env?.VITE_CLIENT === 'ct-ppl') {
    return subdivisions_ppl;
  }

  return subdivisions;
};

export const countrySubdivisions = getCountrySubdivisions();

export const ensureSubDivisionBelongsToCountry: KeywordDefinition = {
  keyword: 'ensureSubDivisionBelongsToCountry',
  type: 'object',
  validate: (_: any, data: {}) => {
    const subDivisionKey = Object.keys(data).find((key) => key.endsWith('sub_division')) ?? '';
    const countryKey = subDivisionKey.substring(0, subDivisionKey.indexOf('_sub_division'));
    // @ts-expect-error
    const subDivisionValue = data?.[subDivisionKey];
    if (!subDivisionValue) {
      return true;
    }
    // @ts-expect-error
    const countryValue = data?.[countryKey];
    const allowedSubDivisions =
      (isPPL
        ? // @ts-expect-error
          countrySubdivisions?.[countryValue]?.oneOf?.map((i) => i.const)
        : // @ts-expect-error
          countrySubdivisions?.[countryValue]?.enum) ?? [];

    return allowedSubDivisions.includes(subDivisionValue);
  },
  error: {
    message: 'must be equal to one of the allowed values',
  },
};
